import React, {PropsWithChildren} from 'react';
import {useAuth} from './useAuth';

import {Loader} from '@ui/Loader/Loader';
import {Stack, Typography} from '@mui/material';

const AuthWrapper = ({children}: PropsWithChildren) => {
    const {isLogin, isError} = useAuth();

    if (!isLogin && !isError) {
        return <Loader />;
    }

    if (isError) {
        return (
            <Stack padding='16px'>
                <Typography variant='h2'>
                    Сервер не отвечает, попробуйте перезагрузить страницу
                </Typography>
            </Stack>
        );
    }

    return children;
};

export default AuthWrapper;
